import { render, staticRenderFns } from "./proportion.vue?vue&type=template&id=56030749&"
import script from "./proportion.vue?vue&type=script&lang=js&"
export * from "./proportion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports